module.exports = __webpack_public_path__ + "static/media/iconCantineActive.224d9525.svg";